import { render } from "./PayoutCompensationDetail.vue?vue&type=template&id=7928c36e&scoped=true&ts=true"
import script from "./PayoutCompensationDetail.vue?vue&type=script&lang=ts"
export * from "./PayoutCompensationDetail.vue?vue&type=script&lang=ts"

import "./PayoutCompensationDetail.vue?vue&type=style&index=0&id=7928c36e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7928c36e"]])

export default __exports__